import {createReducer} from 'redux-act';

import {
    SONGS_FETCH_DATA_INIT,
    SONGS_FETCH_DATA_SUCCESS,
    SONG_FETCH_DATA_SUCCESS,
    SONGS_FETCH_DATA_FAIL,
    SONGS_DELETE_SONG_INIT,
    SONGS_DELETE_SONG_SUCCESS,
    SONGS_DELETE_SONG_FAIL,
    SONGS_CREATE_SONG_INIT,
    SONGS_CREATE_SONG_SUCCESS,
    SONGS_CREATE_SONG_FAIL,
    SONGS_MODIFY_SONG_INIT,
    SONGS_MODIFY_SONG_SUCCESS,
    SONGS_MODIFY_SONG_FAIL,
    SONGS_CLEAN_UP,
    SONGS_CLEAR_DATA_LOGOUT,
} from 'state/actions/songs';

const initialState = {
    data: [],
    song: null,
    total: 0,
    page: 1,
    loading: false,
    error: null,
    success: false,
    deleted: false,
    sortConfig: {
      attribute: 'name',
      order: 'asc'
    }
};

export const songsReducer = createReducer(
    {
        [SONGS_FETCH_DATA_INIT]: () => ({
            ...initialState,
            loading: true,
        }),
        [SONG_FETCH_DATA_SUCCESS]: (state, payload) => ({
            ...state,
            song: payload.song,
            loading: false,
            error: null,
        }),
        [SONGS_FETCH_DATA_SUCCESS]: (state, payload) => ({
            ...state,
            data: payload.data,
            total: payload.total,
            page: payload.page,
            sortConfig: payload.sortConfig,
            loading: false,
            error: null,
        }),
        [SONGS_FETCH_DATA_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [SONGS_DELETE_SONG_INIT]: (state) => ({
            ...state,
            loading: true,
        }),
        [SONGS_DELETE_SONG_SUCCESS]: (state, payload) => ({
            ...state,
            data: state.data.filter((elem) => elem.id !== payload.id),
            loading: false,
            error: null,
            deleted: true,
        }),
        [SONGS_DELETE_SONG_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [SONGS_CREATE_SONG_INIT]: (state) => ({
            ...state,
            loading: true,
        }),
        [SONGS_CREATE_SONG_SUCCESS]: (state, payload) => ({
            ...state,
            data: state.data.concat(payload.song),
            loading: false,
            error: null,
            success: true,
        }),
        [SONGS_CREATE_SONG_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [SONGS_MODIFY_SONG_INIT]: (state) => ({
            ...state,
            loading: true,
        }),
        [SONGS_MODIFY_SONG_SUCCESS]: (state, payload) => ({
            ...state,
            data: !state.data
                ? []
                : state.data.map((elem) => {
                    if (elem.id === payload.id) {
                        return {
                            name: payload.song.name,
                            id: payload.id,
                            img: payload.song.img,
                            url: payload.song.url,
                            artists: payload.song.artists,
                            createdAt: payload.song.createdAt,
                        };
                    }
                    return elem;
                }),
            loading: false,
            error: null,
            success: true,
        }),
        [SONGS_MODIFY_SONG_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [SONGS_CLEAN_UP]: (state) => ({
            ...state,
            loading: false,
            error: null,
            success: false,
            deleted: false,
        }),
        [SONGS_CLEAR_DATA_LOGOUT]: () => ({
            ...initialState,
        }),
    },
    initialState
);
